import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
request.get('/api/devicetype/page', Object.assign({}, options, { params }));

export const treeChildren = (params, options) =>
  request.get('/api/devicetype/treeChildren', Object.assign({}, options, { params }));

export const getDetail = (params, options) =>
request.get('/api/devicetype/detail', Object.assign({}, options, { params }))

export const remove = (params, options) =>
request.post('/api/devicetype/remove', qs.stringify(params),options);

export const add = (params, options) =>
request.post('/api/devicetype/submit', params,options)

export const update = (params, options) =>
request.post('/api/devicetype/submit', params,options)

export const tree = (params, options) =>
  request.get('/api/devicetype/getDeviceTypeWeightingTree', Object.assign({}, options, { params }));
  // request.get('/api/devicetype/tree', Object.assign({}, options, { params }));

export const getTree = (params, options) =>
  request.get('/api/devicetype/getDeviceTypeWeightingTree', Object.assign({}, options, { params }));
  // request.get('/api/devicetype/getTree', Object.assign({}, options, { params }));
